<template>
  <div class="_component-login">
    <component class="_login-wrap" :is="componentName" />
  </div>
</template>
<script>
import _ from 'lodash';
import LOGIN_STATE from './loginState';
import LoginHelper from 'utils/login';
import { wecom_param_key, bindWecom } from 'utils/wecom/index';
export default {
  name: 'Login',
  provide() {
    return {
      Login: this,
      showPassword: this.showPassword
    };
  },
  components: {
    LoginComponent: () => import('./Login/index.vue'),
    Find: () => import('./Find/index.vue'),
    Regist: () => import('./Regist/index.vue'),
    Info: () => import('./Info/index.vue'),
    Sms: () => import('./WX/index.vue'),
    // Sms: () => import('./Sms/index.vue'),
    School: () => import('./School/index.vue')
  },
  props: {
    initState: {
      type: String,
      default: LOGIN_STATE.SMS
    },
    options: {
      default: () => ({})
    },
    showPassword: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    componentName() {
      let ret = '';
      switch (this.state) {
        case LOGIN_STATE.LOGIN: {
          ret = 'LoginComponent';
          break;
        }
        case LOGIN_STATE.REGIST: {
          ret = 'Regist';
          break;
        }
        case LOGIN_STATE.COMPLETE_INFO: {
          ret = 'Info';
          break;
        }
        case LOGIN_STATE.FIND_PASSWORD: {
          ret = 'Find';
          break;
        }
        case LOGIN_STATE.SMS: {
          ret = 'Sms';
          break;
        }
        case LOGIN_STATE.SCHOOL: {
          ret = 'School';
          break;
        }
      }
      return ret;
    },
    LOGIN_STATE() {
      return LOGIN_STATE;
    }
  },
  data: () => ({
    state: '',
    successData: {}
  }),
  created() {
    this.state = this.initState;
  },
  methods: {
    setState(state) {
      // 切换tab时停止微信登录轮询
      if (this.state === this.LOGIN_STATE.SMS && state !== this.LOGIN_STATE.SMS) {
        this.$login.stopMpLogin();
      }
      this.$emit('changeState', state);
      this.state = state;
    },
    async loginSuccess(data) {
      this.$login.cleanMpLoginKey();
      this.successData = data;
      this.setLoginState(data.type, data.token);
      let userType = this.$store.state.lastLoginType;
      if (userType === LoginHelper.ROLES.STUDENT) {
        let status = await this.$_getStuStatusData(true);
        if (!status?.activate_status_v5?.info_completed) {
          this.setState(LOGIN_STATE.COMPLETE_INFO);
          window.history.replaceState(window.history.state, null, '/info');
        } else {
          await this.infoSuccess();
        }
      } else if (userType === LoginHelper.ROLES.TEACHER) {
        await this.$api.post.postBuryDot({
          event: 'teacher_login',
          payload: {
            teacher_name: data.name
          }
        });
        await this.success(data);
      } else {
        await this.success(data);
      }
    },
    async infoSuccess() {
      await this.success();
    },
    setLoginState: function(role, token) {
      switch (role) {
        case LoginHelper.API_ROLES.STUDENT: {
          LoginHelper.setLogin(LoginHelper.ROLES.STUDENT, token);
          break;
        }
        case LoginHelper.API_ROLES.SCHOOL: {
          LoginHelper.setLogin(LoginHelper.ROLES.SCHOOL, token);
          break;
        }
        case LoginHelper.API_ROLES.SL: {
          LoginHelper.setLogin(LoginHelper.ROLES.SL, token);
          break;
        }
        case LoginHelper.API_ROLES.TEACHER: {
          LoginHelper.setLogin(LoginHelper.ROLES.TEACHER, token);
          break;
        }
      }
    },
    async success(successData = this.successData) {
      let userType = this.$store.state.lastLoginType;
      this.$store.dispatch('setLoginData', {
        role: userType,
        data: {}
      });
      if (this.options.success && _.isFunction(this.options.success)) {
        this.options.success(successData);
      } else {
        let is_dl = successData?.is_dl || false;
        let wecom_params = this.$route.query[wecom_param_key];
        let redirect = this.$route.query.r;
        let search = this.$route.query.s;
        if (userType === LoginHelper.ROLES.STUDENT && wecom_params) {
          bindWecom(decodeURIComponent(wecom_params));
        } else if (!this.modal && redirect && redirect !== '') {
          window.location.href = search ? `${redirect}?s=${search}` : decodeURIComponent(redirect);
        } else {
          if (is_dl) {
            this.$router.push({ name: 'deans-list' });
          } else if (userType === LoginHelper.ROLES.SCHOOL) {
            this.$router.push({ name: 'school-studentApply' });
          } else if (userType === LoginHelper.ROLES.STUDENT) {
            this.$isNew.refresh();
            // 学生 判断 用户状态 直接跳转页面
            this.$stuStatusRedirect();
          } else if (userType === LoginHelper.ROLES.TEACHER) {
            window.location.href = '/dashboard';
            // this.$router.push({
            //   name: successData.is_admin ? 'admin' : 'teacher'
            // });
            // this.$router.push({ name: 'teacher' });
          }
        }
      }
    }
  }
};
</script>
<style lang="less" scoped src="./index.less"></style>
